import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import { setSnackbarMessage } from '../model/configuratorSlice';
import { EndPoints, FeedbackMessages } from '../model/constants';
import { markContactFormAsSent } from '../utils/contactFormStorage';

export default function ContactUsService() {
    const { promotionSlug } = useParams();
    const dispatch = useDispatch();

    return useMutation(
        ['contactUsQuery'],
        ({
            nombre, apellidos, telefono, email,
        }) => {
            const contactUsUrl = `${EndPoints.ContactUs}/${promotionSlug}/contact-us`;
            const data = {
                name: nombre,
                surname: apellidos,
                phone: telefono,
                email,
            };
            return axios.post(contactUsUrl, data);
        },
        {
            onSuccess: () => {
                markContactFormAsSent(promotionSlug);
                dispatch(setSnackbarMessage(FeedbackMessages.ContactUsSuccess));
            },
            onError: (error) => {
                console.log(error);
                dispatch(setSnackbarMessage(FeedbackMessages.ContactUsError));
            },
        },
    );
}
